import { Container, Flex, Title, Text, createStyles } from "@mantine/core"
import { Image } from "shared/ui/Image"
import image from "shared/assets/empty.svg"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  title: {
    [theme.fn.smallerThan("sm")]: {
      fontSize: theme.headings.sizes.h2.fontSize,
    },
  },
}))

// ----------------------------------------------------------------------

export function EmptyResult(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Container size="lg" my={48} p={0}>
      <Flex direction="column" align="center" justify="center">
        <Image src={image} alt="Нет данных" maw={288} objectFit="contain" px="xl"/>
        <Title align="center" mt="xl" className={classes.title}>
          Ничего не найдено
        </Title>
        <Text align="center" c="dimmed" mt="xs">
          Попробуйте изменить параметры запроса
        </Text>
      </Flex>
    </Container>
  )
}
